import { useRef, useEffect } from 'react';

import { Stack, Button, TextField } from '@mui/material';

import { useFeedbackContext } from '../hooks/useFeedbackContext';

function OtherFeedback() {
  const { onClose } = useFeedbackContext();
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const feedback = formData.get('otherFeedback') as string;
    onClose(feedback);
  };

  return (
    <Stack
      direction="row"
      pt="9px"
      spacing={1}
      alignItems="center"
      component="form"
      onSubmit={handleSubmit}
    >
      <TextField
        inputRef={inputRef}
        name="otherFeedback"
        label="What can be improved?"
        size="small"
        sx={{ maxWidth: 320 }}
        fullWidth
        focused
      />
      <Button variant="contained" size="small" type="submit">
        Send
      </Button>
      <Button variant="text" size="small" onClick={() => onClose()}>
        Close
      </Button>
    </Stack>
  );
}

export default OtherFeedback;
